import type { CSSResult } from 'lit';
import { css } from 'lit';
import { figmaAppVariables as figmaAppVariablesDark } from './variables-dark.styles';
import { figmaAppVariables } from './variables.styles';

export const appStyles: CSSResult = css`
  :host {
    display: block;
    width: 100%;
    height: 100vh;
    min-height: -webkit-fill-available;
    background-color: var(--white);
    font-family: var(--font-family-primary), sans-serif;
  }
`;

export const appVariables: CSSResult[] = [
  figmaAppVariables, // Light mode

  css`
    :host {
      /* BASIC */
      --white: #fff;
      --black: #000;

      /*FONTS*/
      --font-family-primary: Poppins, 'Poppins Fallback', Arial;
      --font-family-secondary: 'Paytone One', 'Paytone One Fallback', Arial;
      --font-letter-spacing: '-0.02em';

      /* ELEMENT SIZES */
      --header-height: calc(56px + var(--safe-area-top) + var(--top-space-height, 0px));
      --bottom-nav-height: calc(60px + var(--safe-area-bottom));
      --desktop-center-size: 1330px;
      --app-sidebar-width: 300px;
      --account-sidebar-width: 360px;

      /* IOS */
      --safe-area-top: env(safe-area-inset-top);
      --safe-area-bottom: env(safe-area-inset-bottom);
      --safe-area-left: env(safe-area-inset-left);
      --safe-area-right: env(safe-area-inset-right);

      /* VIEWPORT */
      /* Capped against width: crawlers render with a very tall virtual viewport, where an
         uncapped 100dvh inflates full-height blocks and pushes content thousands of px down.
         The cap never binds on real devices — portrait ratios stay well below 2.5. */
      --viewport-height: min(100vh, calc(100vw * 2.5));
    }

    @supports (height: 100dvh) {
      :host {
        --viewport-height: min(100dvh, calc(100vw * 2.5));
      }
    }

    @media screen and (max-width: 1599px) {
      :host {
        --desktop-center-size: 930px;
      }
    }

    @media screen and (max-width: 1440px) {
      :host {
        --app-sidebar-width: 280px;
        --account-sidebar-width: 320px;
      }
    }
  `,

  figmaAppVariablesDark // Dark mode
];
